import { observable, action } from 'mobx';
import ApiCaller from '../../utils/api-caller';
import LocalStorage from '../../utils/localStorage';

const spaPendingOrderKey = 'Pending_Spa_';

class spaStore {

    // Main Properties

    @observable menu = null;
    @observable spaItems = [];
    @observable spaFilterItems = [];
    @observable spaPendingOrders = [];
    @observable spaRemark = '';
    @observable spaAdditionalRemark = '';
    @observable spaLoading = false;
    @observable spaSearchText = '';
    @observable spaSearchSubCategory = 'All';
    @observable spaTotalOrder = 0;

    // Spa Detail Modal

    @observable spaDetail = null;
    @observable showSpaDetailModal = false;
    @observable spaAdditionalItems = [];
    @observable spaDetailLoading = false;
    @observable spaItemTotalPrice = 0;
    @observable spaAddOrderLoading = false;

    // Spa Tab

    @observable spaTabCategories = [];
    @observable spaTabSubCategories = [];
    @observable spaTabCategoryIdActive = '0';

    // Spa Confirm

    @observable spaSubTotal = 0;
    @observable spaVat = 0;
    @observable spaVatTax = 0;
    @observable spaServiceFee = 0;
    @observable spaServiceFeeTax = 0;
    @observable spaTotal = 0;

    @observable spaTimeSelected = 'now';
    @observable spaTimeDeliver = '';
    @observable spaTimeDeliverDate = '';

    @observable spaPaymentOption = 'Cash';

    // Swipe
    @observable swipeX = 0;
    @observable isSwipe = false;

    // Initialization

    @action initGetSpas(roomNo) {
        const that = this;

        const languageCode = window.localStorage.getItem('lang') || 'en';
        return ApiCaller.CmsTasks.getSpas(languageCode).then((spaResponses) => {
            if (spaResponses) {
                that.menu = spaResponses.menu;
                that.spaTabCategories = spaResponses.categoryNames;

                if (that.spaTabCategoryIdActive === '0') {
                    that.spaTabSubCategories = that.spaTabCategories[0].subCategories;
                    that.spaTabCategoryIdActive = that.spaTabCategories[0].taskId.toString();
                } else {
                    const category = this.spaTabCategories.find(fi => fi.taskId === parseInt((that.spaTabCategoryIdActive)));
                    that.spaTabSubCategories = category.subCategories;
                }

                that.spaItems = spaResponses.items;
                that.spaFilterItems = that.spaItems;

                if (that.spaFilterItems.length > 0) {
                    that.spaFilterItems.map((spaItem) => {
                        return spaItem.orderQuantity = 0;
                    });

                    const spaOrders = this.getSpaPendingOrdersFromStorage(roomNo);
                    if (spaOrders !== null) {
                        spaOrders.map((spaOrder) => {
                            let spaItem = that.spaFilterItems.find(it => it.taskId === spaOrder.taskId);
                            if (spaItem) {
                                spaItem.orderQuantity = spaOrder.orderQuantity;
                                spaItem.additionalItems = spaOrder.additionalItems;
                                spaItem.additionalRemark = spaOrder.additionalRemark;
                                spaItem.remark = spaOrder.remark;
                            }
                            return spaItem;
                        })
                    }
                } else {
                    that.menu = null;
                    that.spaTabCategories = [];
                    that.spaTabSubCategories = [];
                    that.spaItems = [];
                    that.spaFilterItems = [];
                    that.spaSearchText = '';
                    that.spaSearchSubCategory = 'All';
                }
            } else {
                that.menu = null;
                that.spaTabCategories = [];
                that.spaTabSubCategories = [];
                that.spaItems = [];
                that.spaFilterItems = [];
                that.spaSearchText = '';
                that.spaSearchSubCategory = 'All';
            }

            this.searchSpaByNameAndSubCategory();
        });
    }

    @action refreshSpas(roomNo) {
        const that = this;

        const languageCode = window.localStorage.getItem('lang') || 'en';
        return ApiCaller.CmsTasks.getSpas(languageCode).then((spaResponses) => {
            if (spaResponses) {
                that.menu = spaResponses.menu;
                that.spaTabCategories = spaResponses.categoryNames;

                if (that.spaTabCategoryIdActive === '0') {
                    that.spaTabSubCategories = that.spaTabCategories[0].subCategories;
                    that.spaTabCategoryIdActive = that.spaTabCategories[0].taskId.toString();
                } else {
                    const category = this.spaTabCategories.find(fi => fi.taskId === parseInt((that.spaTabCategoryIdActive)));
                    that.spaTabSubCategories = category.subCategories;
                }

                that.spaItems = spaResponses.items;
                that.spaFilterItems = that.spaItems;

                if (that.spaFilterItems.length > 0) {
                    that.spaFilterItems.map((spaItem) => {
                        return spaItem.orderQuantity = 0;
                    });

                    const spaOrders = this.getSpaPendingOrdersFromStorage(roomNo);
                    if (spaOrders !== null) {
                        spaOrders.map((spaOrder) => {
                            let spaItem = that.spaFilterItems.find(it => it.taskId === spaOrder.taskId);
                            if (spaItem) {
                                spaItem.orderQuantity = spaOrder.orderQuantity;
                                spaItem.additionalItems = spaOrder.additionalItems;
                                spaItem.additionalRemark = spaOrder.additionalRemark;
                                spaItem.remark = spaOrder.remark;
                            }
                            return spaItem;
                        })
                    }
                }
            } else {
                that.menu = null;
                that.spaTabCategories = [];
                that.spaTabSubCategories = [];
                that.spaItems = [];
                that.spaFilterItems = [];
                that.spaSearchText = '';
                that.spaSearchSubCategory = 'All';
            }

            this.searchSpaByNameAndSubCategory();
        });
    }

    @action initSpaConfirm(roomNo) {
        this.spaRemark = '';
        this.spaTimeSelected = 'now';
        this.spaTimeDeliver = '';

        let data = LocalStorage.Get(spaPendingOrderKey + roomNo);
        if (data !== null) {
            this.spaPendingOrders = data;
        }

        const languageCode = window.localStorage.getItem('lang') || 'en';
        return ApiCaller.CmsTasks.getSpa(languageCode).then(resp => {
            this.menu = resp;

            this.spaVatTax = resp.vat;
            this.spaServiceFeeTax = resp.serviceFee;

            this.setSpaPriceDetail();
        });
    }

    @action initTotalSpaOrder(roomNo) {
        const orders = LocalStorage.Get(spaPendingOrderKey + roomNo);

        if (orders) {
            let quantity = 0;
            orders.map(order => {
                quantity = quantity + order.orderQuantity;

                return order;
            });

            this.spaTotalOrder = quantity;
        } else {
            this.spaTotalOrder = 0;
        }
    }

    // Transaction Action

    @action goToSpaConfirmPage(roomNo) {
        const spaItems = this.spaItems.filter(item => item.orderQuantity > 0);
        LocalStorage.Save(spaPendingOrderKey + roomNo, spaItems);
        this.initTotalSpaOrder(roomNo);
        return LocalStorage.Get(spaPendingOrderKey + roomNo);
    }

    @action removeSpaOrders(roomNo) {
        this.spaItems = [];
        this.spaFilterItems = this.spaItems;
        LocalStorage.Remove(spaPendingOrderKey + roomNo);
    }

    @action backToSpaMainPage(roomNo) {
        const spaPendingOrders = this.spaPendingOrders.filter(item => item.orderQuantity > 0);

        if (spaPendingOrders) {
            LocalStorage.Save(spaPendingOrderKey + roomNo, spaPendingOrders);
        } else {
            LocalStorage.Save(spaPendingOrderKey + roomNo, []);
        }
    }

    // GET Properties

    @action getSpaDetailBySpaTaskId(taskId) {
        this.spaDetailLoading = true;
        this.spaAdditionalItems = [];
        this.spaDetail = null;

        const spaItem = this.spaFilterItems.find(it => it.taskId === taskId);

        if (spaItem) {
            this.spaDetail = spaItem;
            this.spaAdditionalItems = spaItem.additionalItems;

            this.setSpaItemTotalPrice();
        }

        this.spaDetailLoading = false;
        this.showSpaDetailModal = true;

        return spaItem;
    }

    @action getSpaPendingOrders() {
        return this.spaPendingOrders.filter(it => it.orderQuantity > 0);
    }

    @action getSpaPendingOrdersFromStorage(roomNo) {
        return LocalStorage.Get(spaPendingOrderKey + roomNo);
    }

    // Set Properties

    @action setSpaRemark(value) {
        this.spaRemark = value;
    }

    @action setSpaItemQty(taskId, value) {
        const spaItem = this.spaFilterItems.find(it => it.taskId === taskId);
        spaItem.orderQuantity = value;

        this.setSpaItemTotalPrice();
    }

    @action setSpaPendingOrderQty(taskId, value) {
        const spaPendingOrder = this.spaPendingOrders.find(it => it.taskId === taskId);
        spaPendingOrder.orderQuantity = value;

        this.setSpaPriceDetail();
    }

    @action setShowSpaDetailModal(value) {
        this.showSpaDetailModal = value;
    }

    @action setSpaPriceDetail() {
        this.spaSubTotal = 0;

        this.spaPendingOrders.map((order) => {
            if (order.price === order.specialPrice) {
                this.spaSubTotal = this.spaSubTotal + (order.orderQuantity * (order.price + order.additionalPrice))
            } else {
                this.spaSubTotal = this.spaSubTotal + (order.orderQuantity * (order.specialPrice + order.additionalPrice))
            }

            return this.spaSubTotal;
        });

        this.spaVat = this.spaSubTotal * this.spaVatTax / 100;
        this.spaServiceFee = this.spaSubTotal * this.spaServiceFeeTax / 100;
        this.spaTotal = this.spaSubTotal + this.spaServiceFee + this.spaVat;
    }

    @action setSpaTimeSelected(value) {
        this.spaTimeSelected = value
        this.spaTimeDeliver = ''
    }

    @action setSpaTimeDeliver(value) {
        this.spaTimeDeliver = value
        this.spaTimeSelected = ''
    }

    @action setSpaTimeDeliverDate(value) {
        this.spaTimeDeliverDate = value
    }

    @action setRadioButtonSelected(spaAdditionalItemId, spaAdditionalItemDetailId) {
        const spaAdditionalItem = this.spaDetail.additionalItems.find(fi => fi.spaAdditionalItemId === spaAdditionalItemId);
        if (spaAdditionalItem) {
            spaAdditionalItem.itemDetails.map(itemDetail => {
                if (itemDetail.spaAdditionalItemDetailId === spaAdditionalItemDetailId) {
                    itemDetail.isSelected = true;
                } else {
                    itemDetail.isSelected = false;
                }
                return itemDetail;
            });
        }

        this.setSpaItemTotalPrice();
    }

    @action setCheckSelected(spaAdditionalItemId, spaAdditionalItemDetailId, isChecked) {
        const spaAdditionalItem = this.spaDetail.additionalItems.find(fi => fi.spaAdditionalItemId === spaAdditionalItemId);
        if (spaAdditionalItem) {
            const itemDetail = spaAdditionalItem.itemDetails.find(fi => fi.spaAdditionalItemDetailId === spaAdditionalItemDetailId);

            if (isChecked) {
                const selectedItemDetail = spaAdditionalItem.itemDetails.filter(fi => fi.isSelected);
                const totalSelectedItemDetail = selectedItemDetail.length;
                if (totalSelectedItemDetail < spaAdditionalItem.maxNumber) {
                    itemDetail.isSelected = isChecked;
                }
            } else {
                itemDetail.isSelected = isChecked;
            }
        }

        this.setSpaItemTotalPrice();
    }

    @action setSpaItemTotalPrice() {
        let additionalPrice = 0;

        if (this.spaDetail.additionalItems) {
            this.spaDetail.additionalItems.map(item => {
                item.itemDetails.map(itemDetail => {
                    if (itemDetail.isSelected) {
                        additionalPrice = additionalPrice + itemDetail.price;
                    }
                    return itemDetail;
                });
                return item;
            });
        }

        if (this.spaDetail.price === this.spaDetail.specialPrice) {
            this.spaItemTotalPrice = this.spaDetail.orderQuantity * (this.spaDetail.price + additionalPrice);
        } else {
            this.spaItemTotalPrice = this.spaDetail.orderQuantity * (this.spaDetail.specialPrice + additionalPrice);
        }

        this.spaDetail.additionalPrice = additionalPrice;

    }

    @action setSpaAdditionalRemark() {
        this.spaAdditionalRemark = '';

        if (this.spaDetail.additionalItems) {
            this.spaDetail.additionalItems.map(item => {
                item.itemDetails.map(itemDetail => {
                    if (itemDetail.isSelected) {
                        if (this.spaAdditionalRemark === '') {
                            this.spaAdditionalRemark = `${itemDetail.subItemName}, `;
                        } else {
                            this.spaAdditionalRemark = `${this.spaAdditionalRemark}${itemDetail.subItemName}, `;
                        }
                    }
                    return itemDetail;
                })
                return item;
            });
        }

        this.spaDetail.additionalRemark = this.spaAdditionalRemark;
    }

    @action setRemark(value) {
        this.spaDetail.remark = value;
    }

    @action searchSpaByNameAndSubCategory() {
        if (this.spaSearchText === '' && this.spaSearchSubCategory === 'All') {
            this.spaFilterItems = this.spaItems;
            return;
        }

        if (this.spaSearchSubCategory === 'All') {
            this.spaFilterItems = this.spaItems;
        } else {
            this.spaFilterItems = this.spaItems.filter(item => {
                let subCategoryName = item.subCategoryName.toLowerCase();
                return subCategoryName.indexOf(this.spaSearchSubCategory.toLowerCase()) !== -1;
            });
        }

        if (this.spaSearchText !== '') {
            this.spaFilterItems = this.spaFilterItems.filter(item => {
                let itemTaskName = item.taskName.toLowerCase();
                return itemTaskName.indexOf(this.spaSearchText.toLowerCase()) !== -1;
            });
        }
    }

    @action setSpaSearchText(value) {
        this.spaSearchText = value;
    }

    @action setSpaSearchSubCategory(value) {
        this.spaSearchSubCategory = value;
    }

    @action setSpaTabSubCategoriesByTabCategoryTaskId(tabCategoryTaskId) {
        this.spaTabCategoryIdActive = tabCategoryTaskId.toString();
        const category = this.spaTabCategories.find(fi => fi.taskId === parseInt(tabCategoryTaskId));

        if (category) {
            if (category.subCategories.length > 0) {
                this.spaTabSubCategories = category.subCategories;
                return;
            }
        }

        this.spaTabSubCategories = [];
    }

    @action setSpaPaymentOption(value) {
        this.spaPaymentOption = value;
    }

    @action setSwipeX(value) {
        this.swipeX = value;
    }

    @action setIsSwipe(value) {
        this.isSwipe = value;
    }

    @action setSpaAddOrderLoading(value) {
        this.spaAddOrderLoading = value;
    }

    // RESET Properties

    @action resetSpas() {
        this.spaItems = [];
        this.spaFilterItems = this.spaItems;
    }
}

export default new spaStore()